import { isProd } from './config'
import { db, FirebaseDocRefType } from 'firebase/index'
export const MELLOW_SHOP_ID = isProd ? 'vuNVObluo09j8ty4AwNe' : 'kJ9pHIojCqOiQLH7r72s'
export const MELLOW_SHOP_REF: FirebaseDocRefType = db.collection('shops').doc(MELLOW_SHOP_ID)
